import parse, { domToReact, Element } from 'html-react-parser';

export const renderContentWithAd = (html: string) => {
	const parsed = parse(html, {
		replace: (domNode) => {
			if (domNode instanceof Element && domNode.name === 'body') {
				return <>{domToReact(domNode.children)}</>;
			}
			return undefined;
		}
	});

	const nodes = Array.isArray(parsed) ? parsed : [parsed];
	const insertIndex = Math.floor(nodes.length * 0.25);

	return {
		beforeAd: nodes.slice(0, insertIndex),
		afterAd: nodes.slice(insertIndex)
	};
};
